import { SxProps, Theme } from '@mui/material/styles';

export const SX_ROUTE: SxProps<Theme> = {
  '&:after': { display: 'none' },
  display: 'inline-block',
  marginTop: { lg: 'calc(var(--logo) * 1/8)', xs: 'calc(var(--logo-m) * 1/8)' },
  position: 'absolute',
};

export const SX_IMAGE: SxProps<Theme> = {
  height: { lg: 'calc(var(--logo) * 7/8)', xs: 'calc(var(--logo-m) * 7/8)' },
  width: { lg: 'var(--logo)', xs: 'var(--logo-m)' },
};
